module.exports = __webpack_public_path__ + "img/bg.dd00f93f.png";